import Component from 'vue-class-component';
import PageRender from '@/models/PageRender';

@Component
export default class CreatePurchaseComponent extends PageRender {
    public async mounted() {
        this.isLoading = false;
    }
}
